//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  shouldShowLoader: boolean;
}

const LOADING_BAR_HEIGHT = '8px';

const LoadingBar = (props: Props) => {
  const { children, className, shouldShowLoader } = props;

  return shouldShowLoader ? <Bar className={className} /> : <>{children}</>;
};

const Bar = styled.div.attrs<{ className: string }>(({ className }) => ({
  className: `${className} loading-element loading-bar gradient`,
}))`
  height: ${LOADING_BAR_HEIGHT};
`;

export default LoadingBar;
